import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { useField } from "react-final-form";
import { MultipleFileInput } from "@vk-hr-tek/ui/input";
import { composeValidators } from "../validation/index.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function MultipleFileInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else MultipleFileInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const MultipleFileInput_MultipleFileInput = (t0)=>{
    const $ = c(24);
    const { label, labelIcon, tooltip, required, name, validate, disabled: t1, description, dropzoneText, withAuth, cache, maxLength, validationWithoutTouch: t2, validationWhenDisabled: t3, error: errorOverride, errorText, withCounter } = t0;
    const disabled = void 0 === t1 ? false : t1;
    const validationWithoutTouch = void 0 === t2 ? false : t2;
    const validationWhenDisabled = void 0 === t3 ? false : t3;
    let t4;
    if ($[0] !== validate) {
        t4 = validate || [];
        $[0] = validate;
        $[1] = t4;
    } else t4 = $[1];
    let t5;
    if ($[2] !== t4) {
        t5 = composeValidators(t4);
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const validators = t5;
    let t6;
    if ($[4] !== validators) {
        t6 = {
            validate: validators
        };
        $[4] = validators;
        $[5] = t6;
    } else t6 = $[5];
    const { input, meta } = useField(name, t6);
    const { onChange, onBlur } = input;
    const errorDisabled = disabled || !validationWhenDisabled;
    const renderError = !errorDisabled && validationWithoutTouch ? !!input.value && !!meta.error : meta.touched && !!meta.error;
    const t7 = errorOverride || renderError;
    const t8 = errorText || renderError && meta.error;
    let t9;
    if ($[6] !== cache || $[7] !== description || $[8] !== disabled || $[9] !== dropzoneText || $[10] !== input || $[11] !== label || $[12] !== labelIcon || $[13] !== maxLength || $[14] !== onBlur || $[15] !== onChange || $[16] !== required || $[17] !== t7 || $[18] !== t8 || $[19] !== tooltip || $[20] !== validators || $[21] !== withAuth || $[22] !== withCounter) {
        t9 = /*#__PURE__*/ jsx(MultipleFileInput, _object_spread_props(_object_spread({}, input), {
            value: input.value,
            label: label,
            labelIcon: labelIcon,
            disabled: disabled,
            required: required,
            tooltip: tooltip,
            onChange: onChange,
            onBlur: onBlur,
            cache: cache,
            validate: validators,
            error: t7,
            helperText: t8,
            description: description,
            dropzoneText: dropzoneText,
            maxLength: maxLength,
            withAuth: withAuth,
            withCounter: withCounter
        }));
        $[6] = cache;
        $[7] = description;
        $[8] = disabled;
        $[9] = dropzoneText;
        $[10] = input;
        $[11] = label;
        $[12] = labelIcon;
        $[13] = maxLength;
        $[14] = onBlur;
        $[15] = onChange;
        $[16] = required;
        $[17] = t7;
        $[18] = t8;
        $[19] = tooltip;
        $[20] = validators;
        $[21] = withAuth;
        $[22] = withCounter;
        $[23] = t9;
    } else t9 = $[23];
    return t9;
};
export { MultipleFileInput_MultipleFileInput as MultipleFileInput };
